module.exports = __webpack_public_path__ + "static/model.9677af64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model.svg
// module id = 491
// module chunks = 35783957827783